<template>
  <div class="loadingio-spinner-dual-ring-yv5sd3a663b">
    <div class="ldio-g3co1sy13xg">
      <div></div>
      <div>
        <div></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Preloader",
};
</script>
